import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import clsx from 'clsx';

import { ADORNMENT_ICON_SIZE } from './constants';
import { IAdornmentIconProps } from './types';

import styles from './AdornmentIcons.module.scss';

export const AdornmentIcon: FC<IAdornmentIconProps> = ({text, children, size = ADORNMENT_ICON_SIZE.LARGE }) => {
  const { t } = useTranslation()
  return (
    <Typography variant="subtitle2" className={clsx(size === ADORNMENT_ICON_SIZE.SMALL && styles.small)}>
      {children ? children : t(text)}
    </Typography>
  );
};
